import { WIDGET_SIZES, WIDGET_TYPES } from 'components/global/ManageWidgets/widgetsUtils';

export const homePageChartsConfigRaw = {
	'/home': [
		{
			id: 'pendingPreparation',
			type: WIDGET_TYPES.pie,
			size: WIDGET_SIZES.medium
		},
		{
			id: 'pendingPickup',
			type: WIDGET_TYPES.pie,
			size: WIDGET_SIZES.medium
		},
		{
			id: 'pendingDelivery',
			type: WIDGET_TYPES.pie,
			size: WIDGET_SIZES.medium
		},
		{
			id: 'closedOrders',
			type: WIDGET_TYPES.pie,
			size: WIDGET_SIZES.medium
		},
		{
			id: 'processingOrders',
			type: WIDGET_TYPES.pie,
			size: WIDGET_SIZES.medium
		},
		{
			id: 'deliveryCompDistribution',
			type: WIDGET_TYPES.bar,
			size: WIDGET_SIZES.medium,
			infoMessage: 'widgets.overview.deliveryCompDistribution.infoMessage'
		},
		{
			id: 'dashboard.orderDistributionWeekly',
			type: WIDGET_TYPES.column,
			size: WIDGET_SIZES.medium
		},
		{
			id: 'dashboard.orderDistributionDaily',
			type: WIDGET_TYPES.column,
			size: WIDGET_SIZES.medium
		},
		{
			id: 'topDestinations',
			type: WIDGET_TYPES.cards,
			size: WIDGET_SIZES.medium
		},
		{
			id: 'deliveryCompDistributionDashboard',
			type: WIDGET_TYPES.cards,
			size: WIDGET_SIZES.medium,
			infoMessage: 'dashboard.dashboard.deliveryCompDistribution.infoMessage'
		},
		{
			id: 'saleChannelDistribution',
			type: WIDGET_TYPES.cards,
			size: WIDGET_SIZES.medium,
			authorizationPath: 'SalesChannelModule'
		}
	]
};
